import { SolidButton } from 'dbi-pearl-ui-kit';
import { useNavigate } from 'react-router-dom';

const { useTranslation } = require('react-i18next');
const { default: RefreshModalContantWrapper } = require('./RefreshModalContant.styled');

export const RefreshPageModal = (props) => {
    const { t } = useTranslation();
    const navigate = useNavigate();

    const refreshPage = () => {
        navigate(0);
    };

    return (
        <RefreshModalContantWrapper>
            <h3 className="title">{t('Pages.VendorDetailsPage.RefreshPageModalTitle')}</h3>
            <p className="content">{t('Pages.VendorDetailsPage.RefreshPageModalContant')}</p>
            <SolidButton onClick={refreshPage} className="refreshButton">
                {t('Pages.VendorDetailsPage.RefreshPageButton')}
            </SolidButton>
        </RefreshModalContantWrapper>
    );
};
